import { openProDialog, openStarterDialog, openTeamDialog } from "@/shared";
import Button, { type ButtonSize } from "@components/ui/button";
import { cn } from "@lib/cn";
import { UPGRADE_BUTTON_VARIANTS } from "../constants";

interface IProps {
  feature: string;
  size?: ButtonSize;
  callback?: () => void;
  plan: string;
  className?: string;
}

const UpgradeButton = ({
  size = "xs",
  feature,
  callback,
  plan,
  className,
}: IProps) => {
  const onClick = () => {
    if (plan === "starter") return openStarterDialog(feature);
    else if (plan === "pro") return openProDialog(feature);
    openTeamDialog(feature);
  };

  return (
    <Button
      className={cn(className, "tw-shadow-xs")}
      variant={
        UPGRADE_BUTTON_VARIANTS[plan as keyof typeof UPGRADE_BUTTON_VARIANTS] ||
        "secondary"
      }
      size={size}
      onClick={(e) => {
        e.stopPropagation();
        onClick();
        callback?.();
      }}
    >
      <Button.Icon icon="ri-vip-crown-fill" className="!tw-opacity-100" />
      Upgrade now
    </Button>
  );
};

export default UpgradeButton;
